/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AtsConnectionResponseCapabilitiesSnapshot } from './atsConnectionResponseCapabilitiesSnapshot';
import type { AtsConnectionResponseSyncDirection } from './atsConnectionResponseSyncDirection';
import type { AtsConnectionResponseSyncSettings } from './atsConnectionResponseSyncSettings';
import type { AtsConnectionTalentPool } from './atsConnectionTalentPool';

export interface AtsConnectionResponse {
  id: string;
  connector_id: string;
  connector_name: string;
  connector_domain?: string | null;
  status: string;
  connected_by_name?: string | null;
  last_sync_at?: string | null;
  capabilities_snapshot?: AtsConnectionResponseCapabilitiesSnapshot;
  sync_direction?: AtsConnectionResponseSyncDirection;
  sync_settings: AtsConnectionResponseSyncSettings;
  talent_pool?: AtsConnectionTalentPool | null;
  created_at: string;
  updated_at: string;
}
